"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import TikTokEmbed from "./TikTokEmbed";
import { useTranslation } from "react-i18next";
import SHeading from "@/components/atoms/SHeading";
import { tiktok_thumbnail } from "@/constants/imagesUrl";
const videos = [
  <TikTokEmbed
    key="video1"
    videoId="7475534852138306834"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail1}
  />,
  <TikTokEmbed
    key="video2"
    videoId="7479659211035626759"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail2}
  />,
  <TikTokEmbed
    key="video3"
    videoId="7481170184284245255"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail3}
  />,
  <TikTokEmbed
    key="video4"
    videoId="7481627923875663122"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail4}
  />,
  <TikTokEmbed
    key="video5"
    videoId="7482756458451307794"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail5}
  />,
  <TikTokEmbed
    key="video6"
    videoId="7482967668530679047"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail6}
  />,
  <TikTokEmbed
    key="video7"
    videoId="7483508996750576903"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail7}
  />,
  <TikTokEmbed
    key="video8"
    videoId="7484446390437924104"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail8}
  />,
  <TikTokEmbed
    key="video9"
    videoId="7485169612544314632"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail9}
  />,
  <TikTokEmbed
    key="video10"
    videoId="7485553913433689352"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail10}
  />,
  <TikTokEmbed
    key="video11"
    videoId="7561011907600338183"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail11}
  />,
  <TikTokEmbed
    key="video12"
    videoId="7534710606063078657"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail12}
  />,
  <TikTokEmbed
    key="video13"
    videoId="7575156192310332693"
    username="snapbox_photobooth"
    thumbnail={tiktok_thumbnail.tiktok_thumbnail13}
  />,
];

const DeliveryAndBrands = () => {
  const { t } = useTranslation();
  return (
    <section className="">
      <div className="max-w-7xl mx-auto px-4">  
        <SHeading
          text={t("home.delivery_and_brands.title")}
          tAlign="center"
          className="font-bold md:text-3xl text-xl mb-8"  
        />
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          spaceBetween={10}
          slidesPerView={1}
          breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        }}
          grabCursor={true}
          resistance={true}
          resistanceRatio={0.85}
          threshold={5}
          touchStartPreventDefault={false}
          preventInteractionOnTransition={false}
          allowTouchMove={true}
          className="custom-swiper custom-swiper-mobile"
        >
          {videos.map((item, index) => (
            <SwiperSlide
              className="mb-10 flex justify-center"
              key={index}
            >
              <div className="flex md:mt-10 flex-col items-center">
                <div className="flex items-center justify-center">{item}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default DeliveryAndBrands;
